import { isValidCron } from 'cron-validator';

import { composeValidators } from './composeValidators';
import { required } from './required';
import { TValidator } from './types';
import { ETL_INTEGRATION_TYPE } from '../../components/configuration/types';
import { ETLTaskType, JOB_NAMES, TASK_NAMES, UserSynchronizationTaskType } from '../../scene/integrations/types';

export const CRON_EXPRESSION_KEY = 'validation.cronExpression';

export const validCronExpression: TValidator = (value) => {
  if (value === undefined || value === '' || value === null) {
    return undefined;
  }

  // input is not null safe therefore value is wrapped in `String()`
  if (isValidCron(String(value), { alias: true, allowBlankDay: true })) {
    return undefined;
  }

  return CRON_EXPRESSION_KEY;
};

const isRoleMappingDefined = (task: UserSynchronizationTaskType) => {
  const roleMappingKeys = Object.keys(task.taskProperties?.roleMapping ?? {});
  if (!roleMappingKeys.length) {
    return false;
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const key of roleMappingKeys) {
    if (task.taskProperties?.roleMapping ? task.taskProperties.roleMapping[key].length : 0) {
      return true;
    }
  }

  return false;
};

const isGroupFilteringEnabled = (task: UserSynchronizationTaskType) => {
  return task.taskProperties?.importAllTeams === false;
};

export const validateCronExpressionOfTask = (task: ETLTaskType) => {
  const isUserSynchronizationTask = task.taskName.endsWith(JOB_NAMES.userSynchronization);
  const isRoleMappingConfigured =
    isUserSynchronizationTask && isRoleMappingDefined(task as UserSynchronizationTaskType);
  const isGroupSupervisorConfigured =
    task.taskName === TASK_NAMES.userSynchronization(ETL_INTEGRATION_TYPE.zoomcc) &&
    task.taskProperties?.groupSupervisors.length;
  const isLookBackPeriodConfigured = !isUserSynchronizationTask && !!task.taskProperties?.lookBackPeriod;

  return task.scheduled ||
    isRoleMappingConfigured ||
    isLookBackPeriodConfigured ||
    isGroupSupervisorConfigured ||
    isGroupFilteringEnabled(task)
    ? composeValidators(required, validCronExpression)(task.cronExpression)
    : validCronExpression(task.cronExpression);
};
